import React, { FC } from 'react'
import Head from 'next/head'
import { ONE_TRUST_DOMAIN_SCRIPT_ID } from '@moonpig/web-core-brand/config'
import { useFlag } from '@moonpig/web-core-eppo/browser'

type OneTrustCookieBannerProps = {
  environmentName: string | undefined
}

const OneTrustScript: FC<OneTrustCookieBannerProps> = ({ environmentName }) => {
  return (
    <>
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        // eslint-disable-next-line react/no-unknown-property
        charSet="UTF-8"
        data-domain-script={`${ONE_TRUST_DOMAIN_SCRIPT_ID}${
          environmentName === 'local' ? '-test' : ''
        }`}
        data-testid={
          environmentName === 'local'
            ? 'one-trust-cookie-banner-local'
            : 'one-trust-cookie-banner'
        }
      />
      <script
        type="text/javascript"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() { document.activeElement.blur(); }`,
        }}
      />
    </>
  )
}

export const OneTrustCookieBanner: FC<OneTrustCookieBannerProps> = ({
  environmentName,
}) => {
  const enableThirdPartyScripts = useFlag('third-party-scripts', {
    fallback: true,
  })
  const enableGTagConsentBeforeOneTrust = useFlag(
    'enable-gtag-consent-before-one-trust',
    { fallback: false },
  )

  if (!enableThirdPartyScripts) {
    return null
  }

  if (enableGTagConsentBeforeOneTrust) {
    return (
      <Head>
        <script
          data-testid="gtag-consent-script"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){ dataLayer.push(arguments); }
            gtag('consent', 'default', {
              security_storage: 'granted',
              functionality_storage: 'denied',
              analytics_storage: 'denied',
              ad_storage: 'denied',
              ad_user_data: 'denied',
              ad_personalization: 'denied',
              personalization_storage: 'denied',
              wait_for_update: 500
            });
          `,
          }}
        />
        <OneTrustScript environmentName={environmentName} />
      </Head>
    )
  }
  return <OneTrustScript environmentName={environmentName} />
}
